import ComingSoonImg from '@/assets/images/coming-soon.png';

export default function ComingSoon() {
    return (
        <div className='w-full h-full flex flex-col justify-center items-center'>
            <img src={ComingSoonImg} alt='Coming soon' />
            <div className='mt-[min(60px,10vw)] text-center font-semibold text-fs-mid14 sm:text-fs-mid20 sm:leading-8'>
                現在システムメンテナンス中のため、
                <br className='block xsm:hidden' />
                ご利用いただけません。
                <br />
                ご不便をおかけし申し訳ございません。
            </div>
        </div>
    );
}
